<template>
  <div v-if="isDemo" class="expiry-notice">
    <span class="badge">Temporary Demo</span>
    <span class="time"><strong>{{ remaining }}</strong> left</span>
  </div>
</template>

<script>
import { instance } from '../store/axios'

export default {
  name: 'DemoExpiryNotice',
  emits: ['expired'],
  data() { return { isDemo: false, expiresAt: null, remaining: '--:--:--', timer: null } },
  async mounted() {
    try {
      const response = await instance.get('/auth/demo/')
      if (response.data.is_demo) {
        this.isDemo = true
        const secondsRemaining = Math.max(1, Number(response.data.seconds_remaining) || 0)
        this.expiresAt = new Date(Date.now() + secondsRemaining * 1000)
        this.tick()
        this.timer = window.setInterval(this.tick, 1000)
      }
    } catch (_) {
      this.isDemo = false
    }
  },
  beforeUnmount() { if (this.timer) window.clearInterval(this.timer) },
  methods: {
    tick() {
      const seconds = Math.max(0, Math.floor((this.expiresAt.getTime() - Date.now()) / 1000))
      const hours = String(Math.floor(seconds / 3600)).padStart(2, '0')
      const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0')
      const remainder = String(seconds % 60).padStart(2, '0')
      this.remaining = `${hours}:${minutes}:${remainder}`
      if (seconds === 0) {
        window.clearInterval(this.timer)
        this.$emit('expired')
      }
    }
  }
}
</script>

<style scoped>
.expiry-notice { margin-left: auto; padding: 6px 10px; display: inline-flex; align-items: center; gap: 8px; border: 1px solid #fde68a; border-radius: 999px; background: linear-gradient(135deg, #fffbeb, #fefce8); color: #78350f; font-size: 12px; white-space: nowrap; }
.badge { padding: 3px 6px; border-radius: 999px; background: rgba(234, 179, 8, .14); color: #92400e; font-size: 10px; font-weight: 700; letter-spacing: .04em; text-transform: uppercase; }
.time { display: inline-flex; gap: 4px; align-items: baseline; }
strong { font-variant-numeric: tabular-nums; }
@media (max-width: 991.98px) { .expiry-notice { margin: 8px 0 4px; } }
</style>
